import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileObject } from '@app/core/models/file-object';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { LoggingService } from './logging.service';

@Injectable({
    providedIn: 'root',
})
export class FileHelperService {
    private readonly apiRoot = `${environment.apiRoot}sessions`;

    constructor(private http: HttpClient, private loggingService: LoggingService) { }

    getFiles(sessionId: string): Observable<FileObject[]> {
        if (!sessionId?.trim()) {
            return throwError(() => new Error('Session ID is required to load files.'));
        }

        const url = `${this.apiRoot}/${encodeURIComponent(sessionId)}/files`;
        return this.http.get<FileObject[]>(url).pipe(
            catchError((error) => this.handleError(error))
        );
    }

    private handleError(error: any) {
        // Handle the error in a way that's appropriate for your app context
        this.loggingService.error('Failed to load session files.', error);
        return throwError(() => new Error('Something bad happened; please try again later.'));
    }
}
